import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs } from "firebase/firestore";
import "../styles/Admin.css";
import { useNavigate } from "react-router-dom";



const Admin = () => {
  const [reviews, setReviews] = useState([]);
  const [selectedDate, setSelectedDate] = useState("");
  const navigate = useNavigate();

 useEffect(() => {
  const fetchReviews = async () => {
    const querySnapshot = await getDocs(collection(db, "hotelReviews"));
    const reviewList = querySnapshot.docs.map((doc) => doc.data());

    // ✅ Sort by createdAt (Dececending)
    reviewList.sort((a, b) => {
      const dateA = a.createdAt?.toDate ? a.createdAt.toDate() : new Date(a.createdAt);
      const dateB = b.createdAt?.toDate ? b.createdAt.toDate() : new Date(b.createdAt);
      return dateB - dateA;
    });

    setReviews(reviewList);
  };

  fetchReviews();
}, []);


  const formatDateTime = (timestamp) => {
    if (!timestamp) return "";
    const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
    return date.toLocaleString();
  };
    const handleLogout = () => {
    localStorage.removeItem("isLoggedIn");
    window.location.href = "/admin-login";
    };

    const [expandedIndex, setExpandedIndex] = useState(null);

        const toggleExpand = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
        };



  return (
    <div className="admin-container">
      {/* Background Video */}
      <video autoPlay muted loop className="background-video">
        <source src="/background.mp4" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    
    <div className="admin-panel">
        <button className="log-button" onClick={handleLogout}>
        Logout
        </button>   
        
        <button className="avg-button" onClick={() => navigate("/month")}>Average Rating</button>  

      <h2 className="admin-title">Admin Panel-Centuria Group of Hotels</h2>
      <hr></hr>
      <div className="filter-section">
        <label><strong>Filter by Date: </strong></label>
        <input
            type="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
        />
        <button onClick={() => setSelectedDate("")}>
            Clear
        </button>
        </div>
       {reviews
        .filter((review) => {
            if (!selectedDate) return true; // Show all if no filter

            const reviewDate = review.createdAt?.toDate
            ? review.createdAt.toDate()
            : new Date(review.createdAt);

            const formattedReviewDate = reviewDate.toISOString().split("T")[0];
            return formattedReviewDate === selectedDate;
        })
        .map((review, index) => (
            <div className="review-box" key={index}>
            <div
                className="review-header"
                onClick={() => toggleExpand(index)}
                style={{
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                }}
            >
                <p><strong>Submitted:</strong> {formatDateTime(review.createdAt)}</p>
                <span>{expandedIndex === index ? "▼" : "▶"}</span>
            </div>

            {expandedIndex === index && (
                <div className="review-details">
                <p><strong>Hotel Name:</strong> {review.hotelName}</p>
                <p><strong>Name:</strong> {review.name}</p>
                <p><strong>Email:</strong> {review.email}</p>
                <p><strong>Meals:</strong> {review.mealOptions?.join(", ")}</p>
                <p><strong>Overall:</strong> {review.overall} / 5</p>
                <p><strong>Food:</strong> {review.food} / 5</p>
                <p><strong>Service:</strong> {review.service} / 5</p>
                <p><strong>Ambiance:</strong> {review.ambiance} / 5</p>
                <p><strong>Value:</strong> {review.value} / 5</p>
                <p><strong>Review:</strong> {review.review}</p>
                </div>
            )}
            <hr />
            </div>
            
        ))}


    </div>
    </div>
  );
};

export default Admin;
